import React from "react";
import ActivityCard from "./ActivityCard";

/**
 * Professional activities list with cards
 */
const ActivityList = ({ activities, onEdit, onDelete }) => {
  return (
    <div className="space-y-4">
      {activities.map((activity) => (
        <ActivityCard
          key={activity.id}
          activity={activity}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default ActivityList;


